import apiClient from './apiClient';

const agentService = {
  initChat: () =>
    apiClient.get('/api/v1/agent/chat/init'),

  chat: (question, sessionId) =>
    apiClient.post('/api/v1/agent/chat', { question, sessionId }, {
      timeout: 10000
    }),

  pollStatus: (requestId) =>
    apiClient.get(`/api/v1/agent/chat/status/${requestId}`),

  clearMemory: (sessionId) =>
    apiClient.post('/api/v1/agent/chat/clear-memory', { sessionId }),
};

export default agentService;